import React from "react";
import { Helmet } from "react-helmet";
import { shallowEqual, useSelector, useDispatch } from "react-redux";

import { setRequestStatus } from "../../../application/actions/miscActions";
import { searchMerchantItem } from "../../../application/actions/merchantActions";

import { useDidMount } from "../../../application/hooks";
import { confirmAlert } from "react-confirm-alert";

import {
  BottomSpace,
  MerchantDetailTopNav,
  MerchantDetailButton,
} from "../../components/common";

import { MerchantImage } from "../../../assets";
import Star from "../../../assets/icons/rating.svg";
import District from "../../../assets/icons/location.svg";
import infoIcon from "../../../assets/icons/info.svg";

import {
  MerchantDetailDiscountContainer,
  MerchantMenuContainer,
  ItemsDetails,
  MerchantDetails,
} from "../..";

import BottomNav from "../../components/common/BottomNav/BottomNav";

import "../../../App.css";
import { useHistory } from "react-router";
import { t } from "../../../miscellaneous/language";
import { useMerchantDetails } from "../../../application/hooks/useMerchantDetails";
import { ReactGAImplementation } from "react-ga4";

const MerchantDetailContainer = ({ match, location }) => {
  const { merchantId } = match.params;
  const history = useHistory();

  const [clickedDetail, setClickedDetail] = React.useState(false);
  const [clickedDetailMerchant, setClickedDetailMerchant] =
    React.useState(false);
  const [detailData, setDetailData] = React.useState();
  const [selectedItemCat, setSelectedItemCat] = React.useState("None");
  const [typeModal, setTypeModal] = React.useState(null);
  const [showBackToTop, setShowBackToTop] = React.useState(false);
  const [isMiniCartOpen, setIsMiniCartOpen] = React.useState(false);
  const { data: merchant_details } = useMerchantDetails(merchantId);

  const dispatch = useDispatch();
  const didMount = useDidMount(true);

  const store = useSelector(
    (state) => ({
      cart: state.cart,
      keyword: state.merchants.keyword,
      // merchant_details: state.merchants.details,
      searched_merchant_items: state.merchants.searchedMerchantItems,
      requestStatus: state.app.requestStatus,
      isLoading: state.app.loading,
    }),
    shallowEqual
  );

  const isSearching = store.keyword != null && store.keyword !== "";
  const displayedMerchantItems = isSearching
    ? store.searched_merchant_items?.merchant_items
    : merchant_details.merchant_items;
  const displayedCategories = isSearching
    ? store.searched_merchant_items?.merchant_item_category
    : merchant_details.merchant_item_category;

  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [merchantId]);

  React.useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const shouldShowBackToTop = showBackToTop && !clickedDetail && !clickedDetailMerchant && !isMiniCartOpen;

  const actionClickMerchant = (id, partner_level) => {
    const path = `/merchant/${id}`;
    if (path === window.location.pathname) {
      handleDetailClick(merchant_details, "none", "merchant");
    } else {
      history.push(path);
      console.log(partner_level);
      ReactGAImplementation.event(
        `Click ${partner_level === 1 ? "partner" : "non-partner"}`,
        {
          category: "Click Merchant",
          action: "Click Merchant",
          label: "Click Merchant", // optional
          value: 1, // optional, must be a number
        }
      );
    }
  }

  const MerchantProfile = React.useMemo(() => {
    return (
      <div style={{ margin: 10, borderRadius: 8, backgroundColor: "white" }}>
        <div
          className="merchant-list-card"
          onClick={(e) => {
            merchant_details.is_closed === 1
              ? alert(t.alert.merchantClose)
              : actionClickMerchant(
                merchant_details.id,
                merchant_details.partner_level
              );
          }}
        >
          {merchant_details.is_closed === 0 ? (
            <div className="img-container merchant-list-img">
              <img
                src={merchant_details.image}
                alt=""
                className="merchant-list-img"
                onError={(event) => (event.target.src = MerchantImage)}
              />
              <span className="badge">
                {merchant_details.partner_level == 0 ? "non-partner" : "Partner"}
              </span>
            </div>
          ) : (
            <div
              className="img-container merchant-list-img"
              style={{ backgroundImage: "url(" + merchant_details.image + ")" }}
            >
              <p
                className="merchant-list-img-status"
                style={{
                  color: "white",
                  textAlign: "center",
                  paddingTop: 40,
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                {merchant_details.is_closed === 0
                  ? t.status.Open
                  : t.status.Close}
              </p>
              <span className="badge">
                {merchant_details.partner_level == 0 ? "non-partner" : "Partner"}
              </span>
            </div>
          )}

          <div className="merchant-list-description-wrapper">
            <div className="merchant-list-description-container">
              <span className="merchant-list-name">{merchant_details.name}</span>
              <span className="merchant-list-desc">{merchant_details.desc}</span>
              <div className="merchant-list-detail-container">
                <div className="merchant-detail-list-rating">
                  <img
                    src={Star}
                    id="merchant-icon-info"
                    fill="#FF6000"
                    className="merchant-icon-info"
                  />
                  <span>{merchant_details.avg_rating}</span>
                </div>
                <div className="merchant-detail-list-address ">
                  <img
                    src={District}
                    id="merchant-icon-info"
                    className="merchant-icon-info"
                  />
                  <span className="merchant-info-location">
                    {merchant_details?.address}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {merchant_details.partner_level == 0 ? (
          <div className="alert-information">
            <div className="alert-detail">
              <center>
                <strong>
                  <a>{t.text.info}</a>
                </strong>{" "}
                {t.text.nonPartnerInfo}{" "}
                <img
                  src={infoIcon}
                  onClick={() => checkMerchantPartner("merchants")}
                />
              </center>
            </div>
          </div>
        ) : merchant_details.partner_level == 2 ? (
          <div className="alert-information">
            <div className="alert-detail-plus">
              <a>{t.alert.partnerPlus}&nbsp;</a>
              {/* <img
              src={infoIcon}
              onClick={() => checkMerchantPartner("merchantsPlus")}
            /> */}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    )
  }, [merchant_details]);

  const handleDetailClick = async (itemDetail, itemCat, type) => {
    if (type === "merchant") {
      setDetailData(itemDetail);
      setClickedDetailMerchant(true);
      setTypeModal(type);
    } else if (type === "share") {
      setDetailData(itemDetail);
      setClickedDetailMerchant(true);
      setTypeModal(type);
    } else if (type === "item") {
      if (itemDetail && itemCat) {
        setDetailData(itemDetail);
        setSelectedItemCat(itemCat);
        setClickedDetail(true);
        setTypeModal(type);
      }
    } else if (type === "itemaddexsisting") {
      if (itemDetail && itemCat) {
        // await window.scrollTo(0, 0);
        setDetailData(itemDetail);
        setSelectedItemCat(itemCat);
        setClickedDetail(true);
        setTypeModal(type);
      }
    } else {
      // await dispatch(getMerchantDetails(itemDetail.merchants_id));
      delete location.state;
      setSelectedItemCat("None");
      setClickedDetail(false);
      setClickedDetailMerchant(false);
      setDetailData();      
    }
  };

  const checkMerchantPartner = (type) => {
    switch (type) {
      case "merchants":
        if (merchant_details?.id == merchantId) {
          if (merchant_details?.partner_level == 0) {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className="alert">
                    <h1>{t.alert.nonPartner}</h1>
                    <p>{t.alert.noteNonPartner}</p>
                    <div className="alert-button-container">
                      <button className="yes-button-full" onClick={onClose}>
                        {t.btn.yes}
                      </button>
                    </div>
                  </div>
                );
              },
            });
          }
        }
        break;

      case "merchantsPlus":
        console.log('masuk kesini bre');
        if (merchant_details?.id == merchantId) {
          if (merchant_details?.partner_level == 2) {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div className="alert">
                    <p>{t.alert.partnerPlus}</p>
                    <div className="alert-button-container">
                      <button className="yes-button-full" onClick={onClose}>
                        {t.btn.yes}
                      </button>
                    </div>
                  </div>
                );
              },
            });
          }
        }
        break;
    }
  };

  React.useEffect(() => {    
    if (location?.state !== "undefined") {
      if (history.action === "POP") {
        delete location?.state;
      }
      if (location?.state?.catChoosed === "None") {
        handleDetailClick(
          location.state.item,
          location.state.catChoosed,
          location.state.type
        );
      }
    }
    // checkMerchhantPartner();
  }, [
    didMount,
    merchantId,
    selectedItemCat,
    detailData,
    store.keyword,
    dispatch,
  ]);

  React.useEffect(
    () => () => {
      dispatch(searchMerchantItem(""));
      dispatch(setRequestStatus(""));
      if (localStorage.getItem("merchant-shared")) {
        localStorage.removeItem("merchant-shared");
      }
      // eslint-disable-next-line
    },
    []
  );

  return (
    <>
      <Helmet>
        <title>{`Foods&Goods - ${merchant_details?.name}`}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={merchant_details?.name} />
      </Helmet>
      <div className="wrapper-gray">
        <MerchantDetailTopNav
          title={merchant_details?.name}
          isClicked={clickedDetail}
          handleDetailClick={handleDetailClick}
        />
        {MerchantProfile}
        <MerchantDetailDiscountContainer
          items={displayedMerchantItems}
          search={isSearching}
          detailFunction={handleDetailClick}
          typeUI="mdc"
        />
        <MerchantMenuContainer
          items={displayedCategories}
          search={isSearching}
          detailFunction={handleDetailClick}
        />
        <BottomSpace className="merchant-bottom-space" />
        <MerchantDetailButton onMiniCartStateChange={setIsMiniCartOpen} />
        {shouldShowBackToTop && (
          <button
            type="button"
            className="back-to-top-button"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            ↑
          </button>
        )}
        <BottomNav />
      </div>

      <ItemsDetails
        merchant={merchant_details}
        items={detailData}
        itemCat={selectedItemCat}
        ItemsDetailsModal={clickedDetail}
        handleDetailClick={handleDetailClick}
        type={typeModal}
      />

      <MerchantDetails
        type={typeModal}
        merchant={detailData}
        MerchantDetailsModal={clickedDetailMerchant}
        close={handleDetailClick}
        handleDetailClick={handleDetailClick}
      />
    </>
  );
};

export default MerchantDetailContainer;
